import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "Success" }
const _hoisted_2 = { class: "SubHeading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Close = _resolveComponent("Close")!
  const _component_Final = _resolveComponent("Final")!

  return (_openBlock(), _createBlock(_component_Final, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Close),
        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "lnr-checkmark-circle GeoIcon" }, null, -1 /* CACHED */)),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "MainHeading" }, " We successfully saved your geotargeting settings. ", -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_2, " They will be effective " + _toDisplayString((_ctx.campaignStartDate && `on ${_ctx.campaignStartDate}`) || 'within 24 hours') + ". ", 1 /* TEXT */)
      ])
    ]),
    _: 1 /* STABLE */
  }))
}